export var notificationDTOToParams = function (dto) {
    var page = dto.page ? "&page=" + dto.page : '';
    var pageSize = dto.pageSize ? "&pageSize=" + dto.pageSize : '';
    var onlyUnread = dto.onlyUnread ? '&onlyUnread=true' : '';
    var olderThanTimestamp = dto.olderThanTimestamp ? "&olderThanTimestamp=" + dto.olderThanTimestamp : '';
    return ("" + olderThanTimestamp + pageSize + page + onlyUnread).replace('&', '?');
};
export var createWebNotificationsApi = function (baseUrl, http) {
    var url = baseUrl + "/web-notifications";
    var webNotificationsApi = {
        getNotifications: function (dto) {
            var params = notificationDTOToParams(dto);
            return http.get("" + url + params);
        },
        getUnseenCount: function () {
            return http.get(url + "/unseen/count");
        },
        resetUnseenCount: function () {
            return http.post(url + "/unseen/reset", {});
        },
        setReadStatus: function (dto) {
            return http.post(url + "/" + dto.id + "/setReadStatus", dto);
        },
        markAllRead: function () {
            return http.post(url + "/markRead", {});
        },
        createAnnouncement: function (dto) {
            return http.post(url + "/announcements", dto);
        }
    };
    return webNotificationsApi;
};
//# sourceMappingURL=index.js.map